import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-route-not-found',
  templateUrl: './route-not-found.component.html',
  styleUrls: ['./route-not-found.component.scss']
})
export class RouteNotFoundComponent implements OnInit {

  constructor(private _router: Router) { }

  ngOnInit() {
  }

  goToDashboard() {
    this._router.navigate(['/home']);
  }

}
